<template>
    <button
        class="button"
        :class="bulmaColorClass"
        @click="onClick">

        <template v-if="!loading">
            <span v-if="text.length > 0">{{ text }}</span>
            <span v-if="bulmaIcon.length > 0" class="icon">
                <i class="fas" :class="bulmaIcon"></i>
            </span>
        </template>

        <template v-else>
            <!-- <LoadingSpinner :small-spinner="true"/> -->
            <span class="icon"><i class="fas fa-sync fa-spin"></i></span>
        </template>
    </button>
</template>

<script>
    import LoadingSpinner from '@/widgets/LoadingSpinner.vue'

    export default {
        name: 'LoadingButton',
        components: {LoadingSpinner},
        props: {
            text: {type: String, default: '', required: false},
            loading: {type: Boolean, default: false, required: false},
            bulmaColorClass: {type: String, default: '', required: false},
            bulmaIcon: {type: String, default: '', required: false},
        },
        emits: ['clicked'],
        methods: {
            onClick(){
                this.$emit('clicked')
            },
        },
    }
</script>

